export default __webpack_public_path__ + "static/bg-app-ab14488a81518a848658708b980b9410.webp";